export default "<p>\r\n  Frequently Asked Questions\r\n</p>\r\n";